var React = require('react');

function MenuDots (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"}));
}

MenuDots.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = MenuDots;

MenuDots.default = MenuDots;
